var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.viewOptions,
          expression: "viewOptions",
        },
      ],
      staticClass: "wh-100",
    },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.emptyBox,
            expression: "!emptyBox",
          },
        ],
        ref: "echartDom",
        staticStyle: { height: "100%" },
      }),
      _vm.emptyBox ? _c("emptyBox") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }